/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const CreativeCommonsShareIconConfig = {
  name: 'CreativeCommonsShareIcon',
  height: 512,
  width: 496,
  svgPath: 'M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(CreativeCommonsShareIconConfig);
//# sourceMappingURL=creative-commons-share-icon.js.map